// extracted by mini-css-extract-plugin
export default {"container":"_2JrSDMlqd0aCFAYVEQ_RTU"};